import { z } from 'zod';

import { REQUEST_PUBLIC_CODE_REGEX } from './fallback.js';

export const REQUEST_EXPORT_BATCH_MAX_IDS = 20;

const RequestExportBatchIdSchema = z
  .string()
  .regex(REQUEST_PUBLIC_CODE_REGEX, 'must match LR-NNNNN');

/**
 * @aiPurpose strict request body for the bounded China-request batch XLSX export.
 * @aiInvariant requestIds preserves caller order and contains 1..20 unique
 *   public request codes; unknown keys are rejected at the wire boundary.
 */
export const RequestExportBatchSchema = z
  .object({
    requestIds: z
      .array(RequestExportBatchIdSchema)
      .min(1)
      .max(REQUEST_EXPORT_BATCH_MAX_IDS)
      .refine((ids) => new Set(ids).size === ids.length, 'requestIds must be unique'),
    includeRateColumns: z.boolean(),
  })
  .strict();

export type RequestExportBatch = z.infer<typeof RequestExportBatchSchema>;
